import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from 'src/app/order.service';
import { Store } from 'src/app/models/store';
import { MatDialog } from '@angular/material/dialog';
import { GiftCardBarcodeDialogComponent } from '../my-offers/gift-card-barcode-dialog/gift-card-barcode-dialog.component';

@Component({
  selector: 'app-offer-status',
  templateUrl: './offer-status.component.html',
  styleUrls: ['./offer-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OfferStatusComponent implements OnInit {
  initial;
  storeId;
  offerOrderId;
  offersInCart;
  status;
  isLoading=false;
  displayedColumns: string[] = ['quantity', 'item', 'itemTotal'];
  store:Store;

  // ENG-5034: gift delivery after purchase
  giftDetails: any = null;
  giftSending = false;
  giftSent = false;
  giftSendFailed = false;

  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService,
    private router: Router,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) { }


  ngOnInit() {
    this.storeId = this.route.snapshot.paramMap.get('storeId');
    this.offerOrderId = this.route.snapshot.paramMap.get('offerOrderId');
    this.status = this.route.snapshot.paramMap.get('status');

    this.orderService.getOffer(this.storeId, this.offerOrderId).subscribe(offersInCart => {
      this.offersInCart = offersInCart;
      this.store = Object.assign(new Store(), offersInCart.store);

      // If the backend already knows this was gifted, show gift status from server
      if (offersInCart.gift_info) {
        this.giftDetails = offersInCart.gift_info;
        this.giftSent = true;
        localStorage.removeItem(this.giftDetailsKey);
      }

      this.cdr.markForCheck();
    });

    if (this.status === 'success') {
      this.sendGiftIfNeeded();
    }
  }

  private get giftDetailsKey() {
    return `giftDetails_${this.offerOrderId}`;
  }

  private sendGiftIfNeeded() {
    const saved = localStorage.getItem(this.giftDetailsKey);
    if (!saved) return;
    try {
      this.giftDetails = JSON.parse(saved);
    } catch (e) {
      localStorage.removeItem(this.giftDetailsKey);
      return;
    }
    this.deliverGift();
  }

  deliverGift() {
    if (this.giftSending || this.giftSent) return;
    this.giftSending = true;
    this.giftSendFailed = false;
    this.cdr.markForCheck();
    this.orderService.sendGift(this.offerOrderId, this.giftDetails).subscribe(() => {
      this.giftSending = false;
      this.giftSent = true;
      localStorage.removeItem(this.giftDetailsKey);
      this.cdr.markForCheck();
    }, () => {
      this.giftSending = false;
      this.giftSendFailed = true;
      this.cdr.markForCheck();
    });
  }

  goBack() {
    this.router.navigate(['store', this.storeId, 'offers', 'order', this.offerOrderId]);
  }

  openBarcodeDialog(item: any) {
    this.dialog.open(GiftCardBarcodeDialogComponent, {
      data: {
        card: {
          card_number: item.card_number,
          barcode_image: item.barcode_image
        }
      }
    });
  }
}
